var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"placeholder":_vm.label + (_vm.required && _vm.markRequired ? ' *' : ''),"value":_vm.value,"rules":_vm.rules,"outlined":"","light":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }